import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { BasePage } from '@pages/base/base.page';

@Injectable({
	providedIn: 'root'
})
export class LoginGuard extends BasePage implements CanActivate {
	async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
		let data = await this.storageService.get('user');

		if (data) {
			return true;
		} else {
			this.router.navigate(['/start']);
			return false;
		}
	}
}
